import { render, staticRenderFns } from "./COAAddAllocationModal2.vue?vue&type=template&id=4aaa1654&scoped=true&"
import script from "./COAAddAllocationModal2.vue?vue&type=script&lang=js&"
export * from "./COAAddAllocationModal2.vue?vue&type=script&lang=js&"
import style0 from "./COAAddAllocationModal2.vue?vue&type=style&index=0&id=4aaa1654&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aaa1654",
  null
  
)

export default component.exports